import { render, staticRenderFns } from "./PlanetIcon.vue?vue&type=template&id=594a2db7&"
import script from "./PlanetIcon.vue?vue&type=script&lang=js&"
export * from "./PlanetIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports